import { configureStore } from "@reduxjs/toolkit";

import configReducer from "./adminSlice";
import authReducer from "./authSlice";
import themeReducer from "./theme";
import roleReducer from "./userSlice";
// import chatNotificationReducer from "./chatNotificationSlice";
// import notificationReducer from "./notificationSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    role: roleReducer,
    config: configReducer,
    theme: themeReducer,
    // chatNotification: chatNotificationReducer,
    // notification: notificationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
